import { render, staticRenderFns } from "./PatentCertificate.vue?vue&type=template&id=c5405054&"
import script from "./PatentCertificate.vue?vue&type=script&lang=js&"
export * from "./PatentCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports